import { GET_AUDIT, GET_AUDIT_ERR } from '../../actionTypes/auditType'
import { getAuditApi} from 'api/Api';
import axios from "axios";
import { accessToken } from 'api/Token'
export const getAudit = payload => async dispatch => {
    try {
        ////console.log('payload',payload)
        let results = await axios.get(`${getAuditApi}/${payload}`, await accessToken())
        ////console.log("User Detail", results)
        let data = results && results.data
        dispatch({
            type: GET_AUDIT,
            payload: data || {},
        });
    } catch (error) {   
        dispatch({
            type: GET_AUDIT_ERR,
            payload: error && error.response
        });
    }
}


